// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_33974c2b58--wrapper--zKySF","newbuilding-recommendations-banners-container":"_33974c2b58--newbuilding-recommendations-banners-container--XN3Jx"};